(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const media = window.matchMedia('(max-width: 959px)');

    const syncSection = section => {
      section.querySelectorAll('[data-product-tabs-shared-content]').forEach(content => {
        const blockId = content.dataset.productTabsSharedContent;
        const slotType = media.matches ? 'mobile' : 'desktop';
        const target = section.querySelector(`[data-product-tabs-${slotType}-slot="${CSS.escape(blockId)}"]`);

        if (target && content.parentElement !== target) {
          target.append(content);
        }
      });
    };

    const syncAll = () => {
      document.querySelectorAll('.product-tabs').forEach(syncSection);
    };

    syncAll();
    media.addEventListener('change', syncAll);
    document.addEventListener('shopify:section:load', syncAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
